import PropTypes from 'prop-types';
export const endpointPropTypes = PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    endpoint: PropTypes.string
}));
export const versionPropTypes = PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    version: PropTypes.string
}));
